import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'पृष्ठ सापडले नाही',
  title: 'ते पृष्ठ आम्हाला सापडले नाही',
  body: 'लिंक जुनी झाली असेल, किंवा पृष्ठ काढून टाकले गेले असेल. आपल्याला काय हवे आहे ते सांगा, आम्ही ते शोधून देऊ.',
  suggestionsTitle: 'आपण कदाचित हे शोधत असाल',
  bestMatchTitle: 'आपल्याला हे म्हणायचे होते का',
  prefillHint: 'आपण उघडण्याचा प्रयत्न केलेल्या पत्त्यावरून आधीच भरलेले',
  goHome: 'मुख्यपृष्ठ',
  browseAll: 'सर्व श्रेणी',
  reportBrokenLink: 'बंद पडलेल्या लिंकची तक्रार करा',
  noticeTitle: 'ते पृष्ठ उपलब्ध नाही',
  noticeSearching: 'त्याऐवजी {query} शोधत आहोत…',
  noticePrefilled: 'खाली {query} शोधा, किंवा आपल्याला काय हवे आहे ते सांगा.',
  errorTitle: 'काहीतरी चुकले',
  errorBody: 'हे पृष्ठ लोड करता आले नाही. पुन्हा प्रयत्न करा, किंवा आपल्याला जे हवे आहे ते खाली शोधा.',
  retry: 'पुन्हा प्रयत्न करा',
  streamLostTitle: 'हे पृष्ठ आम्हाला पूर्ण करता आले नाही',
  streamLostBody: 'पृष्ठ जतन होण्यापूर्वीच शोध थांबला. तो पुन्हा सुरू करा, आणि आपल्याच शब्दांवरून आम्ही पुढे सुरू करू.',
  relaunch: 'पुन्हा शोधा',
};
